import Slider from "../common/classes/slider.es6";

export default class TicketProductSlider {
    constructor() {
        document.querySelectorAll(".js-ticket-product-slider").forEach((slider) => {
            const pagination = slider.querySelector(".js-ticket-product-pagination");
            const slideCount = slider.querySelectorAll(".swiper-slide").length;

            new Slider(slider, {
                autoplay: slideCount > 1 ? { delay: 4000, disableOnInteraction: false } : false,
                loop: slideCount > 1,
                slidesPerView: 1,
                pagination: {
                    el: pagination,
                    clickable: true,
                },
            });
        });
    }
}
